module.exports = __webpack_public_path__ + "static/media/156.be760309.wav";